var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton-wrapper",on:{"click":_vm.onClick}},[_c('i',{staticClass:"fa fa-image fa-2x"})])
}
var staticRenderFns = []

export { render, staticRenderFns }